module.exports = __webpack_public_path__ + "img/gonetworktol1.ffb9fb36.png";